import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactInfo = () => {
  const contactDetails = [
    {
      type: 'email',
      label: 'Email Us',
      value: 'singhcreations23@gmail.com',
      description: 'For general inquiries and project discussions',
      icon: 'Mail',
      action: 'mailto:singhcreations23@gmail.com'
    },
    {
      type: 'phone',
      label: 'Call Us',
      value: '+91-7982843491',
      description: '11 AM - 8 PM IST',
      icon: 'Phone',
      action: 'tel:+91-7982843491'
    },
    {
      type: 'address',
      label: 'Visit Us',
      value: 'Tilak Nagar\nNew Delhi, India 110018',
      description: 'By appointment only',
      icon: 'MapPin',
      action: null
    }
  ];

  const socialLinks = [
    // {
    //   platform: 'LinkedIn',
    //   url: 'https://linkedin.com/company/singh-creations',
    //   icon: 'Linkedin',
    //   color: 'text-blue-600'
    // },
    // {
    //   platform: 'Twitter',
    //   url: 'https://twitter.com/singhcreations',
    //   icon: 'Twitter',
    //   color: 'text-blue-400'
    // },
    {
      platform: 'Instagram',
      url: 'https://instagram.com/singhcreations',
      icon: 'Instagram',
      color: 'text-pink-600'
    },
    {
      platform: 'Dribbble',
      url: 'https://dribbble.com/singhcreations',
      icon: 'Dribbble',
      color: 'text-pink-500'
    }
  ];

  const businessHours = [
    { day: 'Monday - Friday', hours: '11:00 AM - 8:00 PM IST' },
    { day: 'Saturday', hours: '10:00 AM - 2:00 PM IST' },
    { day: 'Sunday', hours: 'Closed' }
  ];

  const handleContactClick = (action) => {
    if (action) {
      window.open(action, '_blank');
    }
  };

  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div>
            <h2 className="text-3xl font-bold text-primary mb-6">
              Get in Touch
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              Ready to transform your digital presence? We're here to help you every step of the way. 
              Choose the method that works best for you.
            </p>

            <div className="space-y-6">
              {contactDetails?.map((contact, index) => (
                <div
                  key={index}
                  className={`flex items-start space-x-4 p-6 rounded-xl border border-border hover:border-accent/50 brand-transition ${
                    contact?.action ? 'cursor-pointer brand-hover-lift' : ''
                  }`}
                  onClick={() => handleContactClick(contact?.action)}
                >
                  <div className="p-3 bg-accent/10 rounded-lg">
                    <Icon name={contact?.icon} size={24} className="text-accent" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-foreground mb-1">{contact?.label}</h3>
                    <p className="text-foreground mb-1 whitespace-pre-line">{contact?.value}</p>
                    <p className="text-sm text-muted-foreground">{contact?.description}</p>
                  </div>
                  {contact?.action && (
                    <Icon name="ExternalLink" size={16} className="text-muted-foreground" />
                  )}
                </div>
              ))}
            </div>

            {/* Social Media Links */}
            {/* <div className="mt-8">
              <h3 className="font-semibold text-foreground mb-4">Follow Our Journey</h3>
              <div className="flex space-x-4">
                {socialLinks?.map((social, index) => (
                  <a
                    key={index}
                    href={social?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-3 bg-surface rounded-lg hover:bg-muted brand-transition brand-hover-lift"
                    title={`Follow us on ${social?.platform}`}
                  >
                    <Icon name={social?.icon} size={20} className={social?.color} />
                  </a>
                ))}
              </div>
            </div> */}
          </div>

          {/* Business Hours & Map */}
          <div className="space-y-8">
            {/* Business Hours */}
            <div className="bg-surface p-6 rounded-xl">
              <h3 className="font-semibold text-foreground mb-4 flex items-center space-x-2">
                <Icon name="Clock" size={20} className="text-accent" />
                <span>Business Hours</span>
              </h3>
              <div className="space-y-3">
                {businessHours?.map((schedule, index) => (
                  <div key={index} className="flex justify-between items-center">
                    <span className="text-muted-foreground">{schedule?.day}</span>
                    <span className="font-medium text-foreground">{schedule?.hours}</span>
                  </div>
                ))}
              </div>
              
              <div className="mt-6 p-4 bg-accent/10 rounded-lg">
                <div className="flex items-center space-x-2 mb-2">
                  <Icon name="Info" size={16} className="text-accent" />
                  <span className="font-medium text-accent">Emergency Support</span>
                </div>
                <p className="text-sm text-muted-foreground">
                  For urgent technical issues with existing projects, we offer 24/7 emergency support. 
                  Additional charges may apply.
                </p>
              </div>
            </div>

            {/* Office Location Map */}
            <div className="bg-surface p-6 rounded-xl">
              <h3 className="font-semibold text-foreground mb-4 flex items-center space-x-2">
                <Icon name="MapPin" size={20} className="text-accent" />
                <span>Our Location</span>
              </h3>
              
              <div className="aspect-video rounded-lg overflow-hidden mb-4">
                <iframe
                  width="100%"
                  height="100%"
                  loading="lazy"
                  title="Singh Creations Office Location"
                  referrerPolicy="no-referrer-when-downgrade"
                  // src="https://www.google.com/maps?q=37.7749,-122.4194&z=14&output=embed"
                  src="https://www.google.com/maps?q=28.6490,77.1226&z=14&output=embed"
                  className="border-0"
                />
              </div>
              
              <div className="text-sm text-muted-foreground mb-4">
                <p className="font-medium text-foreground mb-1">Singh Creations</p>
                {/* <p>123 Innovation Drive, Suite 456</p> */}
                <p>Tilak Nagar, Delhi ,110018</p>
              </div>
              
              <Button
                variant="outline"
                size="sm"
                className="w-full"
                iconName="Navigation"
                iconPosition="left"
                onClick={() => window.open('https://maps.google.com?q=28.6490,77.1226', '_blank')}
              >
                Get Directions
              </Button>
            </div>

            {/* Quick Response Promise */}
            <div className="bg-gradient-to-r from-trust/10 to-accent/10 p-6 rounded-xl border border-trust/20">
              <div className="flex items-center space-x-3 mb-3">
                <Icon name="Zap" size={24} className="text-trust" />
                <h3 className="font-semibold text-trust">Our Response Promise</h3>
              </div>
              <div className="space-y-2 text-sm">
                <div className="flex items-center space-x-2">
                  <Icon name="Check" size={16} className="text-success" />
                  <span>Email inquiries: Within 4 hours</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Check" size={16} className="text-success" />
                  <span>Phone calls: Answered during business hours</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Check" size={16} className="text-success" />
                  <span>Consultation requests: Scheduled within 24 hours</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Check" size={16} className="text-success" />
                  <span>Project proposals: Delivered within 48 hours</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;